<template>
    <div class="rightBlock">
      <div class="content">
        <div class="modularOne">
          <div class="title">
            <img src="../../../../../static/img/28.png" alt="">
            <span>本年新增专利统计</span>
          </div>
          <div class="contentBlock contentBlockOne">
            <div class="row" v-for="item in patentList" :key="item.name" @click="detailClick(item)">
              <img :src="item.img" alt="">
              <div>
                <p>{{item.count}}</p>
                <p>{{item.label}}</p>
              </div>
            </div>
          </div>
          <div class="title">
            <img src="../../../../../static/img/28.png" alt="">
            <span>专利奖</span>
          </div>
          <div class="contentBlock contentBlockTwo">
            <Bar :options="options" @echartClick="echartClick"></Bar>
          </div>
        </div>
      </div>
    </div>
</template>
<script>
import { patentIncrease, legalRange, rewardRange } from '@/api/databaseBin'
import Bar from '@/components/echarts/Pie'
import BaseMixin from '@/views/_mixin'
import moment from 'moment'
export default {
  mixins: [BaseMixin],
  data() {
    return {
      patentList: [
        {
          img: require('../../../../../static/img/16.png'),
          label: '新增专利申请',
          name: 'apply',
          count: 0,
          exp: '专利类型=(发明申请 or 实用新型 or 外观设计) and (公开年 = 开始时间)'
        },
        {
          img: require('../../../../../static/img/17.png'),
          label: '新增专利授权',
          name: 'authorization',
          count: 0,
          exp: '专利类型=(发明授权 or 实用新型 or 外观设计) and (公开年 = 开始时间)'
        },
        {
          img: require('../../../../../static/img/15.png'),
          label: '新增发明申请',
          name: 'inventApply',
          count: 0,
          exp: '专利类型=(发明申请) and (公开年 = 开始时间)'
        },
        {
          img: require('../../../../../static/img/19.png'),
          label: '新增发明授权',
          name: 'effect',
          count: 0,
          exp: '专利类型=发明授权 and (公开年 = 开始时间)'
        }
      ],
      options: {},
      xData: [
        { name: 'public', label: '公开', count: 0 },
        { name: 'examination', label: '实审', count: 0 },
        { name: 'authorization', label: '授权', count: 0 },
        { name: 'turndown', label: '驳回', count: 0 },
        { name: 'withdraw', label: '撤回', count: 0 },
        { name: 'total', label: '总量', count: 0 }
      ],
      xDatas: [],
      seriesDataOne: [],
      seriesDataTwo: [],
      barData: []
    }
  },
  components: {
    Bar
  },
  mounted() {
    this.getPatent()
    this.getLegal()
  },
  methods: {
    echartClick(params) {
      console.log(params, 'params')
      let name = params.name
      if (name === '实审') {
        name = '实质审查'
      }
      let str = `奖励等级=(${name})`
      if (name === '总量') {
        str = '专利类型=(发明申请 or 实用新型 or 外观设计)'
      }
      this.jumpIpi(str, 'isMerge', 'publicOrder')
    },
    detailClick(item) {
      // const startDate = moment().startOf('day').format('YYYY-MM-DD')
      // const endDate = moment().startOf('year').format('YYYY-MM-DD')
      const year = moment().format('YYYY')
      let exp = ''
      exp = item.exp.replace('开始时间', year)
      this.jumpIpi(exp, 'isMerge')
    },
    getPatent() {
      patentIncrease().then((res) => {
        if (res[this.codeMapping]) {
          this.patentList.forEach((item) => {
            res[this.dataMapping].forEach((ele) => {
              if (item.name === ele.name) {
                item.count = ele.count
              }
            })
          })
        }
      })
    },
    async getLegal() {
      // legalRange().then((res) => {
      //   if (res[this.codeMapping]) {
      //     res[this.dataMapping].forEach((ele) => {
      //       this.xData.forEach((item) => {
      //         if (item.name === ele.name) {
      //           this.seriesDataTwo.push(ele.count)
      //           this.seriesDataOne.push(0)
      //           this.xDatas.push(item.label)
      //         }
      //       })
      //     })
      //     this.barEcharts()
      //     for (let i = 1; i < this.seriesDataTwo.length - 1; i++) {
      //       //
      //       for (let j = 0; j < i; j++) {
      //         this.seriesDataOne[i] += this.seriesDataTwo[j]
      //       }
      //     }
      //   }
      // })
      const res = await rewardRange()
      let newArr = []
      res.data.forEach(item => {
        newArr.unshift(item)
      })
      this.barData = newArr
      this.barEcharts()
    },
    barEcharts() {
      var salvProName = this.barData.map(item => item.name)
      var salvProValue = this.barData.map(item => item.count)
      var salvProMax = []
      for (let i = 0; i < salvProValue.length; i++) {
        salvProMax.push(salvProValue[0])
      }
      // 颜色渐变
      const gradList = new this.$echarts.graphic.LinearGradient(0, 0, 1, 0, [
        {
          offset: 0,
          color: 'rgb(0, 113, 252)'
        },
        {
          offset: 1,
          color: 'rgb(75, 226, 236)'
        }
      ])
      this.options = {
        grid: {
          left: '5%',
          right: '5%',
          bottom: '2%',
          top: '5%',
          containLabel: true
        },
        tooltip: {
          trigger: 'axis',
          formatter: function (params) {
            return params[0].name + ' : ' + params[0].value
          }
        },
        xAxis: {
          type: 'value',
          splitLine: {
            show: false,
            lineStyle: {
              color: '#ccc'
            }
          },
          axisTick: {
            show: false
          },
          axisLine: {
            show: false
          },
          axisLabel: {
            show: false,
            color: '#fff'
          }
        },
        yAxis: [
          {
            type: 'category',
            axisLabel: {
              show: true,
              textStyle: {
                color: '#fff',
                fontSize: 17
              }
            },
            splitLine: {
              show: false
            },
            axisTick: {
              show: false
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: '#ccc'
              }
            },
            data: salvProName
          }
        ],
        series: [
          {
            name: '',
            type: 'bar',
            label: {
              show: true,
              position: 'right',
              color: '#fff'
            },
            itemStyle: {
              normal: {
                barBorderRadius: [0, 30, 30, 0],
                color: gradList
              }
            },
            barWidth: 14,
            data: salvProValue
          }
        ]
      }
    }
  }
}
</script>
